import React, { useState } from "react";
import { useSelector } from "react-redux";
import useApi from "../../CustomHooks/useApi";
import RecentTransactions from "./RecentTransactions";
import LedgerReport from "./LedgerReport";
import AepsLedgerReport from "./AepsLedgerReport";
import CommissionLedgerReport from "./CommissionLedgerReport";
import CashInHistory from "./CashInHistory";
import PayoutHistory from "./PayoutHistory";
import AepsHistory from "./AepsHistory";
import MobileRechargeHistory from "./MobileRechargeHistory";
import DmtHistory from "./Dmthistory";
import CcbpHistory from "./CcbpHistory";
import PpiHistory from "./PpiHistory";
import PgHistory from "./PgHistory";
import BbpHistory from "./BbpHistory";
import OdHistory from "./OdHistory";

const SearchUser = () => {

    const username = useSelector((state) => state.auth.employeeDetails?.username);
    const mid = useSelector((state) => state.auth.employeeDetails?.username);
    const role = useSelector((state) => state.auth.employeeDetails?.role);

    const { callApi: searchUser } = useApi("/admin/cashin/search-user", "GET");

    const { callApi: reversalApiCall } = useApi(
        "/p2p/reversal",
        "POST"
    );

    const { callApi: waiverApiCall } = useApi(
        "/admin/cashin/user/waiver",
        "POST"
    );

    const { callApi: getMarkupApi } = useApi("/admin/users/markup/air", "GET");
    const { callApi: updateMarkupApi } = useApi("/admin/users/markup/air", "PUT");


    const { callApi: enableOdApi } = useApi("/od/admin/enable", "POST");
    const { callApi: updateOdApi } = useApi("/od/admin/update", "PUT");
    const { callApi: getOdAccountApi } = useApi("/od/admin/account", "GET");
    const { callApi: disableOdApi } = useApi("/od/admin/disable", "POST");
    const { callApi: unblockOdApi } = useApi("/od/admin/unblock", "POST");

    const { callApi: uploadOdDocApi } = useApi("/od/admin/documents/upload", "POST");

    const { callApi: initiateLienApi } = useApi("/dmt/wallet/initiate/lien-amount", "POST");

    const { callApi: businessWalletCreditApi } = useApi("/business/wallet/credit/v1?show_balance=true", "POST");

    const { callApi: getLienAmount } = useApi("/dmt/wallet/get/lien-amount", "GET");
    const { callApi: editLienHistoryApi } = useApi("/dmt/wallet/admin/lien-history/edit", "PUT");

    const { callApi: getCdmHistoryApi } = useApi("/admin/axis/cdm/card-mapping", "GET");
    const { callApi: deactivateCdmApi } = useApi("/admin/axis/cdm/card-mapping/deactivate", "POST");
    const { callApi: reactivateCdmApi } = useApi("/admin/axis/cdm/card-mapping/reactivate", "POST");


    const [markupType, setMarkupType] = useState("FLAT");
    const [markupValue, setMarkupValue] = useState("");
    const [markupLoading, setMarkupLoading] = useState(false);
    const [markupFetching, setMarkupFetching] = useState(false);
    const [currentMarkup, setCurrentMarkup] = useState({ type: "FLAT", value: "" });

    const [keyword, setKeyword] = useState("");
    const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [activeLedger, setActiveLedger] = useState("MAIN");
    const [activeService, setActiveService] = useState("");

    const [amount, setAmount] = useState("");
    const [remarks, setRemarks] = useState("");
    const [reversalLoading, setReversalLoading] = useState(false);

    // 🔥 modal + toast
    const [showConfirm, setShowConfirm] = useState(false);
    const [resultPopup, setResultPopup] = useState(null);

    const [waiverType, setWaiverType] = useState("");
    const [waiverLoading, setWaiverLoading] = useState(false);
    const [waiverOtp, setWaiverOtp] = useState("");
    const [waiverRemarks, setWaiverRemarks] = useState("");

    const [bwcAmount, setBwcAmount] = useState("");
    const [bwcNote, setBwcNote] = useState("");
    const [bwcLoading, setBwcLoading] = useState(false);
    const [bwcShowConfirm, setBwcShowConfirm] = useState(false);

    const [odData, setOdData] = useState(null);
    const [odLoading, setOdLoading] = useState(false);
    const [odCreditLimit, setOdCreditLimit] = useState("");
    const [odPenalty, setOdPenalty] = useState("0.5");
    const [odPenaltyType, setOdPenaltyType] = useState("PERCENTAGE");
    const [odActionLoading, setOdActionLoading] = useState(false);
    const [odConfirmAction, setOdConfirmAction] = useState(null);
    const [odRemarks, setOdRemarks] = useState("");
    const [odToast, setOdToast] = useState(null);
    const [odOtpPopup, setOdOtpPopup] = useState({ open: false, pendingPayload: null, apiType: null, sentTo: [], apiMessage: "" });
    const [odOtpInput, setOdOtpInput] = useState("");
    const [odOtpError, setOdOtpError] = useState("");
    const [odOtpLoading, setOdOtpLoading] = useState(false);
    const [odMpin, setOdMpin] = useState("");

    const [lienMode, setLienMode] = useState("ADD");
    const [lienAmount, setLienAmount] = useState("");
    const [lienReason, setLienReason] = useState("");
    const [lienRemark, setLienRemark] = useState("");
    const [lienLoading, setLienLoading] = useState(false);
    const [lienConfirm, setLienConfirm] = useState(false);

    // Lien History (Super Admin — auto-fetched from main user search)
    const [lienHistData, setLienHistData] = useState(null);
    const [lienHistLoading, setLienHistLoading] = useState(false);

    // Lien History edit modal
    const [lienEditPopup, setLienEditPopup] = useState({ open: false, row: null });
    const [lienEditForm, setLienEditForm] = useState({ lienAmount: "", remark: "" });
    const [lienEditLoading, setLienEditLoading] = useState(false);
    const [lienEditError, setLienEditError] = useState("");

    // CDM History
    const [cdmHistData, setCdmHistData] = useState(null);
    const [cdmHistLoading, setCdmHistLoading] = useState(false);
    const [cdmDeactivatingId, setCdmDeactivatingId] = useState(null);
    const [cdmReactivatingId, setCdmReactivatingId] = useState(null);

    const fetchMarkupData = async (mid) => {
        if (!mid) return;
        setMarkupFetching(true);
        try {
            const res = await getMarkupApi(null, `?mid=${mid}`);
            if (res?.success && res?.data) {
                const fetchedType = res.data.type || "FLAT";
                const fetchedValue = res.data.value !== undefined ? String(res.data.value) : "";
                setMarkupType(fetchedType);
                setMarkupValue(fetchedValue);
                setCurrentMarkup({ type: fetchedType, value: fetchedValue }); // 👈 Track current
            } else {
                setMarkupType("FLAT");
                setMarkupValue("");
                setCurrentMarkup({ type: "FLAT", value: "" });
            }
        } catch (err) {
            console.error("Failed to fetch markup", err);
            setMarkupType("FLAT");
            setMarkupValue("");
            setCurrentMarkup({ type: "FLAT", value: "" });
        } finally {
            setMarkupFetching(false);
        }
    };

    const handleUpdateMarkup = async () => {
        if (markupValue === "") {
            setResultPopup({ status: "FAILED", message: "Please enter a markup value" });
            return;
        }
        setMarkupLoading(true);
        try {
            const payload = {
                mid: userData?.username,
                type: markupType,
                value: Number(markupValue)
            };
            const res = await updateMarkupApi(payload);
            setResultPopup({
                status: "SUCCESS",
                message: res?.message || "Markup updated successfully"
            });
            setCurrentMarkup({ type: markupType, value: markupValue }); // 👈 Sync after update
        } catch (err) {
            setResultPopup({
                status: "FAILED",
                message: err?.response?.data?.message || err?.message || "Failed to update markup"
            });
        } finally {
            setMarkupLoading(false);
        }
    };


    const fetchLienHistory = async (mobile) => {
        if (!mobile) return;
        setLienHistLoading(true);
        setLienHistData(null);
        try {
            const res = await getLienAmount(null, `?mobileNumber=${mobile}`);
            if (res) setLienHistData(res);
        } catch (err) {
            console.error(err);
        } finally {
            setLienHistLoading(false);
        }
    };

    const openLienEditModal = (row) => {
        setLienEditForm({ lienAmount: row.lienAmount ?? "", remark: row.remark ?? "" });
        setLienEditError("");
        setLienEditPopup({ open: true, row });
    };

    const closeLienEditModal = () => {
        setLienEditPopup({ open: false, row: null });
        setLienEditForm({ lienAmount: "", remark: "" });
        setLienEditError("");
    };

    const handleLienEditSubmit = async () => {
        if (lienEditForm.lienAmount === "" || lienEditForm.lienAmount === null) {
            setLienEditError("Lien amount is required.");
            return;
        }
        setLienEditLoading(true);
        setLienEditError("");
        try {
            const payload = {
                lien_id: lienEditPopup.row.lienId,
                lien_amount: Number(lienEditForm.lienAmount),
                remark: lienEditForm.remark,
                modified_by: username,
            };
            await editLienHistoryApi(payload);
            closeLienEditModal();
            if (userData?.mobile) fetchLienHistory(userData.mobile);
        } catch (err) {
            setLienEditError("Update failed. Please try again.");
        } finally {
            setLienEditLoading(false);
        }
    };

    const lienHistFmt = (val) =>
        val !== undefined && val !== null
            ? `₹ ${Number(val).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
            : "-";

    const fetchCdmHistory = async (mid) => {
        if (!mid) return;
        setCdmHistLoading(true);
        setCdmHistData(null);
        try {
            const res = await getCdmHistoryApi(null, `?mid=${mid}`);
            if (res) setCdmHistData(res);
        } catch (err) {
            console.error(err);
        } finally {
            setCdmHistLoading(false);
        }
    };

    const handleCdmDeactivate = async (cdmCardNo) => {
        setCdmDeactivatingId(cdmCardNo);
        try {
            const res = await deactivateCdmApi(null, `?cdmCardNo=${cdmCardNo}`);
            showOdToast(
                res?.success !== false ? "success" : "error",
                res?.message || "Card deactivated successfully"
            );
            await fetchCdmHistory(userData?.username);
        } catch (err) {
            showOdToast("error", err?.message || "Deactivation failed");
        } finally {
            setCdmDeactivatingId(null);
        }
    };

    const handleCdmReactivate = async (cdmCardNo) => {
        setCdmReactivatingId(cdmCardNo);
        try {
            const res = await reactivateCdmApi(null, `?cdmCardNo=${cdmCardNo}`);
            showOdToast(
                res?.success !== false ? "success" : "error",
                res?.message || "Card reactivated successfully"
            );
            await fetchCdmHistory(userData?.username);
        } catch (err) {
            showOdToast("error", err?.message || "Reactivation failed");
        } finally {
            setCdmReactivatingId(null);
        }
    };

    const generateTxnId = () => {
        const ts = Date.now().toString(36).toUpperCase();
        const rand = Math.random().toString(36).substr(2, 6).toUpperCase();
        return `BW${ts}${rand}`;
    };

    const handleBusinessWalletCredit = async () => {
        try {
            setBwcLoading(true);
            setBwcShowConfirm(false);

            const amountVal = Number(bwcAmount);

            const payload = {
                txn_amount: amountVal,
                currency: "INR",
                txn_category: "CASH_IN",
                txn_category_txn_id: generateTxnId(),
                provider: "BUSINESS_CASH_IN",
                sub_provider: "BUSINESS_CASH_IN",
                party2_breakup: [
                    {
                        party_id: "P1",
                        amount: {
                            value: amountVal,
                            unit: "INR"
                        }
                    }
                ],
                meta: {
                    note: bwcNote
                },
                merchant_account_info: {
                    account_no: userData?.accountNumber,
                    mid: userData?.username
                }
            };

            const res = await businessWalletCreditApi(payload);

            setResultPopup({
                status: res?.txnStatus === "SUCCESS" ? "SUCCESS" : "FAILED",
                message: res?.txnStatus === "SUCCESS" ? "Business wallet credited successfully" : "Transaction failed",
                txnId: res?.business_wallet_txn_id,
                walletBalance: res?.balance?.balance,
            });

            setBwcAmount("");
            setBwcNote("");

        } catch (err) {
            setResultPopup({
                status: "FAILED",
                message: err?.response?.data?.message || "Something went wrong"
            });
        } finally {
            setBwcLoading(false);
        }
    };

    const openConfirmPopup = () => {
        if (!amount || Number(amount) <= 0) {
            setResultPopup({
                status: "FAILED",
                message: "Please enter valid amount"
            });
            return;
        }
        setShowConfirm(true);
    };


    const refreshUserData = async () => {
        if (!keyword) return;

        try {
            const res = await searchUser(
                null,
                `?keyword=${keyword}`
            );

            setUserData(res);
        } catch (err) {
            console.error(err);
        }
    };


    const handleWaiver = async () => {
        try {

            if (!waiverRemarks?.trim()) {
                setResultPopup({
                    status: "FAILED",
                    message: "Remarks is required",
                });
                return;
            }

            if (waiverOtp !== "241830") {
                setResultPopup({
                    status: "FAILED",
                    message: "Invalid Code",
                });
                return;
            }

            setWaiverLoading(true);

            const payload = {
                userId: userData?.userId,
                waiverType,
                cashInWaiverTypeRemarks: waiverRemarks,
            };

            const res = await waiverApiCall(payload);

            setResultPopup({
                status: res?.status || "SUCCESS",
                message: res?.message || "Waiver updated successfully",
            });

            setWaiverOtp("");
            setWaiverRemarks("");

        } catch (err) {
            setResultPopup({
                status: "FAILED",
                message:
                    err?.response?.data?.message || "Something went wrong",
            });
        } finally {
            setWaiverLoading(false);
        }
    };


    const handleUploadDocument = async () => {
        if (!docLabel.trim()) { showOdToast("error", "Document label is required"); return; }
        if (!docFile) { showOdToast("error", "Please select a file to upload"); return; }

        setDocUploading(true);
        try {
            const formData = new FormData();
            formData.append("username", userData?.username);
            formData.append("docLabel", docLabel.trim());
            formData.append("uploadedBy", username);
            formData.append("file", docFile);

            const res = await uploadOdDocApi(formData);
            
            showOdToast("success", res?.message || "Document uploaded successfully");
            setDocLabel("");
            setDocFile(null);
            
            const fileInput = document.getElementById("odFileInput");
            if (fileInput) fileInput.value = "";
            
            await fetchOdData(userData?.username);
        } catch (err) {
            showOdToast("error", err?.response?.data?.message || err?.message || "Document upload failed");
        } finally {
            setDocUploading(false);
        }
    };


    // const fetchOdData = async (uname) => {
    //     setOdLoading(true);
    //     try {
    //         const res = await getOdAccountApi(null, `?username=${uname}`);
    //         setOdData(res ?? null);
    //         if (res?.isOdEnabled) {
    //             if (res.creditLimit)    setOdCreditLimit(String(res.creditLimit));
    //             if (res.penaltyAmount)  setOdPenalty(String(res.penaltyAmount));
    //             if (res.penaltyType)    setOdPenaltyType(res.penaltyType);
    //         } else {
    //             setOdCreditLimit("");
    //             setOdPenalty("0.5");
    //             setOdPenaltyType("PERCENTAGE");
    //             setOdRemarks("");
    //         }
    //     } catch {
    //         setOdData(null);
    //     } finally {
    //         setOdLoading(false);
    //     }
    // };

    const fetchOdData = async (uname) => {
        setOdLoading(true);
        try {
            const res = await getOdAccountApi(null, `?username=${uname}`);
            setOdData(res ?? null);
            if (res?.isOdEnabled) {
                // ✅ ADDED: Set sanctioned amount from response
                if (res.sanctionedAmount !== undefined) setOdSanctionedAmount(String(res.sanctionedAmount)); 
                if (res.creditLimit)    setOdCreditLimit(String(res.creditLimit));
                if (res.penaltyAmount)  setOdPenalty(String(res.penaltyAmount));
                if (res.penaltyType)    setOdPenaltyType(res.penaltyType);
            } else {
                setOdSanctionedAmount(""); // ✅ ADDED: Clear on disabled
                setOdCreditLimit("");
                setOdPenalty("0.5");
                setOdPenaltyType("PERCENTAGE");
                setOdRemarks("");
            }
        } catch {
            setOdData(null);
        } finally {
            setOdLoading(false);
        }
    };

    // const executeOdAction = async () => {
    //     const action = odConfirmAction;
    //     setOdConfirmAction(null);
    //     setOdActionLoading(true);

    //     const uname = userData?.username;
    //     let res;

    //     if (action === "ENABLE") {
    //         res = await enableOdApi({
    //             username: uname,
    //             creditLimit: Number(odCreditLimit),
    //             penaltyAmount: Number(odPenalty) || 0,
    //             penaltyType: odPenaltyType,
    //             remarks: odRemarks,
    //         });
    //     } else if (action === "UPDATE") {
    //         res = await updateOdApi({
    //             username: uname,
    //             creditLimit: Number(odCreditLimit),
    //             penaltyAmount: Number(odPenalty) || 0,
    //             penaltyType: odPenaltyType,
    //             remarks: odRemarks,
    //         });
    //     } else if (action === "DISABLE") {
    //         res = await disableOdApi({ username: uname });
    //     } else if (action === "UNBLOCK") {
    //         res = await unblockOdApi({ username: uname });
    //     }

    //     setResultPopup({
    //         status: res?.success ? "SUCCESS" : "FAILED",
    //         message: res?.message || "Something went wrong",
    //     });

    //     if (res) await fetchOdData(uname);
    //     setOdActionLoading(false);
    // };
    const executeOdAction = async () => {
        const action = odConfirmAction;
        setOdConfirmAction(null);
        setOdActionLoading(true);

        const uname = userData?.username;
        let res;

        const odPayload = {
            username: uname,
            sanctionedAmount: Number(odSanctionedAmount) || 0,
            creditLimit: Number(odCreditLimit),
            penaltyAmount: Number(odPenalty) || 0,
            penaltyType: odPenaltyType,
            remarks: odRemarks,
            mpin: odMpin,
            mid,
        };

        try {
            if (action === "ENABLE") {
                res = await enableOdApi(odPayload);
            } else if (action === "UPDATE") {
                res = await updateOdApi(odPayload);
            } else if (action === "DISABLE") {
                res = await disableOdApi({ username: uname });
            } else if (action === "UNBLOCK") {
                res = await unblockOdApi({ username: uname });
            }

            setResultPopup({
                status: res?.success ? "SUCCESS" : "FAILED",
                message: res?.message || "Something went wrong",
            });

            if (res) await fetchOdData(uname);
        } catch (err) {
            const errData = err?.responseData || {};
            if (errData?.error_code === "OTP_REQUIRED" && errData?.action_params?.otpRequired === true) {
                setOdOtpPopup({
                    open: true,
                    pendingPayload: odPayload,
                    apiType: action,
                    sentTo: errData.action_params?.sentTo || [],
                    apiMessage: errData.message || "",
                });
                setOdActionLoading(false);
                return;
            }
            setResultPopup({
                status: "FAILED",
                message: err?.message || "Something went wrong",
            });
        } finally {
            setOdActionLoading(false);
        }
    };

    const showOdToast = (type, message) => {
        setOdToast({ type, message });
        setTimeout(() => setOdToast(null), 3500);
    };

    // const handleOdEnable = async () => {
    //     if (!odCreditLimit || Number(odCreditLimit) <= 0) {
    //         showOdToast("error", "Please enter a valid credit limit");
    //         return;
    //     }
    //     if (!odRemarks?.trim()) {
    //         showOdToast("error", "Remarks is required");
    //         return;
    //     }
    //     setOdActionLoading(true);
    //     try {
    //         const res = await enableOdApi({
    //             username: userData?.username,
    //             creditLimit: Number(odCreditLimit),
    //             penaltyAmount: Number(odPenalty) || 0,
    //             penaltyType: odPenaltyType,
    //             remarks: odRemarks,
    //         });
    //         showOdToast(
    //             res?.success ? "success" : "error",
    //             res?.message || (res?.success ? "OD enabled successfully" : "Failed to enable OD")
    //         );
    //         if (res?.success) await fetchOdData(userData?.username);
    //     } catch (err) {
    //         showOdToast("error", err?.response?.data?.message || "Something went wrong");
    //     } finally {
    //         setOdActionLoading(false);
    //     }
    // };

    const handleOdEnable = async () => {
        if (!odCreditLimit || Number(odCreditLimit) <= 0) {
            showOdToast("error", "Please enter a valid credit limit");
            return;
        }
        if (!odRemarks?.trim()) {
            showOdToast("error", "Remarks is required");
            return;
        }
        setOdActionLoading(true);
        const payload = {
            username: userData?.username,
            sanctionedAmount: Number(odSanctionedAmount) || 0,
            creditLimit: Number(odCreditLimit),
            penaltyAmount: Number(odPenalty) || 0,
            penaltyType: odPenaltyType,
            remarks: odRemarks,
            mpin: odMpin,
            mid,
        };
        try {
            const res = await enableOdApi(payload);
            showOdToast(
                res?.success ? "success" : "error",
                res?.message || (res?.success ? "OD enabled successfully" : "Failed to enable OD")
            );
            if (res?.success) await fetchOdData(userData?.username);
        } catch (err) {
            const errData = err?.responseData || {};
            if (errData?.error_code === "OTP_REQUIRED" && errData?.action_params?.otpRequired === true) {
                setOdOtpPopup({
                    open: true,
                    pendingPayload: payload,
                    sentTo: errData.action_params?.sentTo || [],
                    apiMessage: errData.message || "",
                });
                return;
            }
            showOdToast("error", err?.message || "Something went wrong");
        } finally {
            setOdActionLoading(false);
        }
    };

    const handleOdOtpSubmit = async () => {
        if (odOtpInput.length !== 6) {
            setOdOtpError("Please enter a valid 6-digit OTP");
            return;
        }
        setOdOtpLoading(true);
        setOdOtpError("");
        try {
            const uname = odOtpPopup.pendingPayload?.username;
            const payload = { ...odOtpPopup.pendingPayload, otp: odOtpInput.trim() };
            let res;
            if (odOtpPopup.apiType === "UPDATE") {
                res = await updateOdApi(payload);
            } else {
                res = await enableOdApi(payload);
            }
            setOdOtpPopup({ open: false, pendingPayload: null, apiType: null, sentTo: [], apiMessage: "" });
            setOdOtpInput("");
            showOdToast(
                res?.success ? "success" : "error",
                res?.message || (res?.success ? "OD action completed successfully" : "OD action failed")
            );
            if (res?.success) await fetchOdData(uname);
        } catch (err) {
            setOdOtpError(err?.message || "Invalid or expired OTP. Please try again.");
        } finally {
            setOdOtpLoading(false);
        }
    };

    const handleOdDisable = async () => {
        setOdActionLoading(true);
        try {
            const res = await disableOdApi({ username: userData?.username });
            showOdToast(
                res?.success ? "success" : "error",
                res?.message || (res?.success ? "OD disabled successfully" : "Failed to disable OD")
            );
            if (res?.success) {
                await fetchOdData(userData?.username);
            }
        } catch (err) {
            showOdToast("error", err?.response?.data?.message || "Something went wrong");
        } finally {
            setOdActionLoading(false);
        }
    };

    const executeLienAction = async () => {
        setLienConfirm(false);
        setLienLoading(true);
        try {
            const payload = {
                mid: userData?.username,
                mode: lienMode,
                reason: lienReason,
                remark: lienRemark,
                modified_by: username,
            };
            if (lienMode !== "UNHOLD") {
                payload.lien_amount = Number(lienAmount);
            }
            const res = await initiateLienApi(payload);
            setResultPopup({
                status: res?.status === "HOLD" || res?.message?.toLowerCase().includes("success") ? "SUCCESS" : "FAILED",
                message: res?.message || "Lien amount updated successfully",
            });
            setLienAmount("");
            setLienReason("");
            setLienRemark("");
        } catch (err) {
            setResultPopup({
                status: "FAILED",
                message: err?.message || "Something went wrong",
            });
        } finally {
            setLienLoading(false);
        }
    };

    const waiverInfo = {
        FULL: {
            title: "Full Waiver Applied",
            color: "green",
            description:
                "No Cash-In charges will be deducted. The merchant receives the full requested amount."
        },
        HALF: {
            title: "Half Waiver Applied",
            color: "yellow",
            description:
                "Cash-In charges will be deducted only for transactions above ₹50,000."
        },
        null: {
            title: "No Waiver Applied",
            color: "red",
            description:
                "No waiver is active. Charges will be deducted on every Cash-In request."
        }
    };

    const currentWaiver =
        waiverInfo[userData?.cashInWaiverType] || waiverInfo.null;


    const confirmReversal = async () => {
        try {
            setReversalLoading(true);

            let targetMid = userData?.username;

            const payload = {
                requesterMid: username,
                targetMid,
                amount: Number(amount),
                currency: "INR",
                walletType: "MRCHNT",
                remarks,
            };

            const res = await reversalApiCall(payload);

            // 🔥 ALWAYS SHOW POPUP (SUCCESS + FAILED)
            setResultPopup({
                status: res?.status || "FAILED",
                message: res?.message,
                txnId: res?.txnId,
                senderBalance: res?.senderBalance,
                receiverBalance: res?.receiverBalance,
            });

            setAmount("");
            setRemarks("");
            setShowConfirm(false);

        } catch (err) {
            console.error(err);

            // 🔥 NETWORK / UNKNOWN ERROR
            setResultPopup({
                status: "FAILED",
                message: err?.response?.data?.message || "Something went wrong",
            });

        } finally {
            setReversalLoading(false);
        }
    };


    const handleSearchMobile = async () => {

        if (!keyword) return;

        setOdData(null);

        try {

            setLoading(true);

            const res = await searchUser(
                null,
                `?keyword=${keyword}`
            );

            setUserData(res);

            if (res?.username) fetchOdData(res.username);
            if (res?.mobile && role === "SUPER_ONBOARDING") fetchLienHistory(res.mobile);
            if (res?.username) fetchCdmHistory(res.username);
            if (res?.username) fetchMarkupData(res.username);

        } catch (error) {

            console.error(error);

        } finally {

            setLoading(false);

        }

    };

    const handleInputChange = (e) => {

        const value = e.target.value;

        setKeyword(value);

        // Agar input clear ho gaya to result bhi clear
        if (!value) {
            setUserData(null);
            setOdData(null);
            setLienHistData(null);
            setCdmHistData(null);
        }

    };


    const maskPan = (pan) => {
        if (!pan) return "-";
        return pan.slice(0, 5) + "****" + pan.slice(-1);
    };

    const maskAadhar = (aadhar) => {
        if (!aadhar) return "-";
        const last4 = aadhar.slice(-4);
        return `XXXX XXXX ${last4}`;
    };


const [odSanctionedAmount, setOdSanctionedAmount] = useState("");
const [docLabel, setDocLabel] = useState("");
const [docFile, setDocFile] = useState(null);
const [docUploading, setDocUploading] = useState(false);



    return (
        <div className="w-full mx-auto pb-24">

            {/* HEADER */}
            <div className="mb-6 bg-gradient-to-r from-[#0A2A4F] to-[#1a4a8f] rounded-2xl p-6 text-white shadow-lg">
                <h2 className="text-2xl font-bold">User Search Dashboard</h2>
                <p className="text-blue-200 text-sm mt-1">Search and manage complete user profiles</p>
            </div>

            {/* SEARCH */}
            <div className="bg-white rounded-2xl shadow-md border p-5 mb-6">
                <label className="text-xs font-semibold text-gray-500 uppercase tracking-wide">Search User</label>
                <div className="flex gap-2 mt-2">
                    <div className="relative flex-1">
                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm">🔍</span>
                        <input
                            type="text"
                            placeholder="Mobile Number / BP User ID / Name"
                            value={keyword}
                            onChange={handleInputChange}
                            onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); handleSearchMobile(); } }}
                            className="w-full border rounded-xl pl-9 pr-4 py-2.5 text-sm focus:ring-2 focus:ring-[#0A2A4F] outline-none"
                        />
                    </div>
                    <button
                        onClick={handleSearchMobile}
                        disabled={loading}
                        className="bg-[#0A2A4F] hover:bg-[#123b6e] disabled:opacity-60 text-white px-7 rounded-xl transition-colors font-semibold text-sm"
                    >
                        {loading ? "Searching..." : "Search"}
                    </button>
                </div>
            </div>

            {/* RESULTS */}
            <div className="space-y-5">
                {loading ? (
                    <div className="bg-white rounded-2xl shadow p-16 flex flex-col items-center gap-3">
                        <div className="w-10 h-10 border-4 border-[#0A2A4F] border-t-transparent rounded-full animate-spin"></div>
                        <p className="text-gray-400 text-sm">Searching user...</p>
                    </div>
                ) : userData ? (
                    <>
                        {/* TOP GRID */}
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">

                            {/* HIERARCHY */}
                            <div className="md:col-span-1 bg-white border rounded-2xl shadow-sm p-4 h-fit">
                                <div className="flex items-center gap-2 mb-4">
                                    <div className="w-1 h-5 bg-[#0A2A4F] rounded-full"></div>
                                    <h3 className="text-sm font-bold text-gray-700">Hierarchy Chain</h3>
                                </div>
                                <div className="space-y-1">
                                    {userData?.hierarchy?.map((h, i) => (
                                        <div key={i} className="flex gap-3 items-start">
                                            <div className="flex flex-col items-center pt-1">
                                                <div className="w-6 h-6 rounded-full bg-[#0A2A4F]/10 text-[#0A2A4F] text-xs font-bold flex items-center justify-center shrink-0">
                                                    {i + 1}
                                                </div>
                                                {i < userData.hierarchy.length - 1 && (
                                                    <div className="w-px h-3 bg-gray-200 mt-1"></div>
                                                )}
                                            </div>
                                            <div className="border rounded-xl px-3 py-2 text-sm flex-1 hover:bg-gray-50 transition mb-1">
                                                <p className="font-semibold text-gray-800 leading-tight">{h.fullName}</p>
                                                <p className="text-xs text-[#0A2A4F] font-medium mt-0.5">{h.role}</p>
                                                <p className="text-xs text-gray-400 mt-0.5">{h.mobile} • {h.bpUserId}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* USER DETAILS */}
                            <div className="md:col-span-2 bg-white border rounded-2xl shadow-sm p-5">

                                {/* USER HEADER */}
                                <div className="flex items-start justify-between gap-4">
                                    <div className="flex items-center gap-4">
                                        <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-[#0A2A4F] to-[#1a4a8f] flex items-center justify-center text-white text-2xl font-bold shadow-md shrink-0">
                                            {userData.fullName?.[0]?.toUpperCase() || "U"}
                                        </div>
                                        <div>
                                            <h2 className="text-lg font-bold text-gray-800">{userData.fullName}</h2>
                                            <span className="inline-block mt-1 px-2.5 py-0.5 bg-blue-100 text-blue-700 text-xs font-semibold rounded-full">
                                                {userData.role}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="bg-gradient-to-br from-green-50 to-emerald-50 border border-green-200 rounded-2xl px-5 py-3 text-right shrink-0">
                                        <p className="text-xs text-gray-500 font-medium">Wallet Balance</p>
                                        <p className="text-2xl font-bold text-green-700 mt-0.5">
                                            ₹ {Number(userData.walletBalance || 0).toLocaleString("en-IN")}
                                        </p>
                                    </div>
                                </div>

                                {/* DETAILS GRID */}
                                <div className="grid grid-cols-2 md:grid-cols-3 gap-x-6 gap-y-4 mt-5 pt-5 border-t text-sm">
                                    {[
                                        { label: "Mobile", value: userData.mobile },
                                        { label: "BP User ID", value: userData.bpUserId },
                                        { label: "PAN Card", value: maskPan(userData.pan) },
                                        { label: "Aadhaar", value: maskAadhar(userData.aadhar) },
                                        { label: "Shop Name", value: userData.shopName },
                                        { label: "Shop Address", value: userData.shopAddress },
                                        { label: "State", value: userData.shopState },
                                        { label: "District", value: userData.shopDistrict },
                                        { label: "Pincode", value: userData.shopPinCode },
                                    ].map(({ label, value }) => (
                                        <div key={label}>
                                            <p className="text-xs text-gray-400 font-medium uppercase tracking-wide">{label}</p>
                                            <p className="font-semibold text-gray-800 mt-0.5 truncate">{value || "—"}</p>
                                        </div>
                                    ))}
                                </div>

                                {/* REVERSAL */}
                                {((role === "SUPER_ONBOARDING" && username === "Naveen1908") ||
                                    (role === "PAYOUT_ACCOUNTING" && username === "USR238811") ||
                                    (role === "PAYOUT_ACCOUNTING" && username === "USR261951")) && (
                                        <div className="border-t mt-5 pt-5">
                                            <p className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-3">Fund Reversal</p>
                                            <div className="grid md:grid-cols-3 gap-3">
                                                <input
                                                    type="text"
                                                    placeholder="Amount (₹)"
                                                    value={amount}
                                                    onChange={(e) => { if (/^\d*$/.test(e.target.value)) setAmount(e.target.value); }}
                                                    className="border rounded-xl px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-gray-400"
                                                />
                                                <input
                                                    type="text"
                                                    placeholder="Remarks"
                                                    value={remarks}
                                                    onChange={(e) => setRemarks(e.target.value)}
                                                    className="border rounded-xl px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-gray-400"
                                                />
                                                <button
                                                    onClick={openConfirmPopup}
                                                    className="bg-gray-800 hover:bg-gray-900 text-white rounded-xl text-sm font-semibold h-[42px] transition-colors"
                                                >
                                                    Reversal
                                                </button>
                                            </div>
                                        </div>
                                    )}

                                {/* BUSINESS WALLET CREDIT */}
                                {/* {role === "SUPER_ONBOARDING" && (
                                        <div className="border-t mt-5 pt-5">
                                            <p className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-3">Business Wallet Credit</p>
                                            <div className="grid md:grid-cols-3 gap-3">
                                                <input
                                                    type="text"
                                                    placeholder="Amount (₹)"
                                                    value={bwcAmount}
                                                    onChange={(e) => { if (/^\d*$/.test(e.target.value)) setBwcAmount(e.target.value); }}
                                                    className="border rounded-xl px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-green-400"
                                                />
                                                <input
                                                    type="text"
                                                    placeholder="Note / Remarks"
                                                    value={bwcNote}
                                                    onChange={(e) => setBwcNote(e.target.value)}
                                                    className="border rounded-xl px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-green-400"
                                                />
                                                <button
                                                    onClick={() => {
                                                        if (!bwcAmount || Number(bwcAmount) <= 0) {
                                                            setResultPopup({ status: "FAILED", message: "Please enter a valid amount" });
                                                            return;
                                                        }
                                                        setBwcShowConfirm(true);
                                                    }}
                                                    disabled={bwcLoading}
                                                    className="bg-green-700 hover:bg-green-800 disabled:opacity-60 text-white rounded-xl text-sm font-semibold h-[42px] transition-colors"
                                                >
                                                    {bwcLoading ? "Processing..." : "Credit Wallet"}
                                                </button>
                                            </div>
                                        </div>
                                    )} */}

                                {/* WAIVER MANAGEMENT */}
                                {role === "SUPER_ONBOARDING" && (
                                    <div className="border-t mt-6 pt-6">
                                        <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-100 rounded-2xl p-5">
                                            <div className="flex items-center justify-between mb-4">
                                                <div>
                                                    <h3 className="text-base font-bold text-gray-800">Cash-In Waiver Management</h3>
                                                    <p className="text-xs text-gray-500 mt-0.5">Configure merchant waiver settings</p>
                                                </div>
                                                <span className={`px-3 py-1 rounded-full text-xs font-bold ${currentWaiver.color === "green" ? "bg-green-100 text-green-700"
                                                        : currentWaiver.color === "yellow" ? "bg-yellow-100 text-yellow-700"
                                                            : "bg-red-100 text-red-700"
                                                    }`}>
                                                    {userData?.cashInWaiverType || "NONE"}
                                                </span>
                                            </div>

                                            <div className={`rounded-xl border p-3 mb-4 ${currentWaiver.color === "green" ? "bg-green-50 border-green-200"
                                                    : currentWaiver.color === "yellow" ? "bg-yellow-50 border-yellow-200"
                                                        : "bg-red-50 border-red-200"
                                                }`}>
                                                <h4 className={`text-sm font-semibold ${currentWaiver.color === "green" ? "text-green-700"
                                                        : currentWaiver.color === "yellow" ? "text-yellow-700"
                                                            : "text-red-700"
                                                    }`}>{currentWaiver.title}</h4>
                                                <p className="text-xs text-gray-600 mt-0.5">{currentWaiver.description}</p>
                                                {userData?.cashInWaiverRemarks && (
                                                    <div className="mt-2 bg-white rounded-lg px-3 py-2 border text-xs">
                                                        <span className="font-semibold text-gray-700">Remarks: </span>
                                                        <span className="text-gray-600">{userData.cashInWaiverRemarks}</span>
                                                    </div>
                                                )}
                                            </div>

                                            <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
                                                <div>
                                                    <label className="block text-xs font-medium text-gray-600 mb-1">Waiver Type</label>
                                                    <select value={waiverType} onChange={(e) => setWaiverType(e.target.value)}
                                                        className="w-full border border-gray-300 rounded-xl px-3 py-2.5 focus:ring-2 focus:ring-blue-500 outline-none text-sm">
                                                        <option value="">Select Type</option>
                                                        <option value="FULL">FULL — No Charges</option>
                                                        <option value="HALF">HALF — Above ₹50,000</option>
                                                        <option value="NONE">NONE — Normal Charges</option>
                                                    </select>
                                                </div>
                                                <div>
                                                    <label className="block text-xs font-medium text-gray-600 mb-1">Security Code</label>
                                                    <input type="password" placeholder="Enter code" value={waiverOtp}
                                                        onChange={(e) => setWaiverOtp(e.target.value)} maxLength={6}
                                                        className="w-full border border-gray-300 rounded-xl px-3 py-2.5 focus:ring-2 focus:ring-blue-500 outline-none text-sm" />
                                                </div>
                                                <div>
                                                    <label className="block text-xs font-medium text-gray-600 mb-1">Remarks</label>
                                                    <input type="text" placeholder="Enter remarks" value={waiverRemarks}
                                                        onChange={(e) => setWaiverRemarks(e.target.value)}
                                                        className="w-full border border-gray-300 rounded-xl px-3 py-2.5 focus:ring-2 focus:ring-blue-500 outline-none text-sm" />
                                                </div>
                                                <div className="flex items-end">
                                                    <button onClick={handleWaiver}
                                                        disabled={!waiverType || !waiverOtp || !waiverRemarks || waiverLoading}
                                                        className="w-full h-[42px] bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 disabled:opacity-50 text-white font-semibold rounded-xl shadow-sm transition-all text-sm">
                                                        {waiverLoading ? "Updating..." : "Update Waiver"}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}


{/* FLIGHT AIR MARKUP MANAGEMENT */}
                                {role === "SUPER_ONBOARDING" && (
                                    <div className="border-t mt-6 pt-6">
                                        <div className="bg-gradient-to-r from-purple-50 to-pink-50 border border-purple-100 rounded-2xl p-5">
                                            <div className="flex items-center justify-between mb-4">
                                                <div>
                                                    <h3 className="text-base font-bold text-gray-800">Flight Air Markup</h3>
                                                    <p className="text-xs text-gray-500 mt-0.5">
                                                        Current Setting: <strong className="text-purple-700">{currentMarkup.value ? `${currentMarkup.value} (${currentMarkup.type})` : "Not Set"}</strong>
                                                    </p>
                                                </div>
                                            </div>

                                            {markupFetching ? (
                                                <div className="flex items-center gap-2 text-gray-500 text-sm py-2">
                                                    <div className="w-4 h-4 border-2 border-purple-400 border-t-transparent rounded-full animate-spin"></div>
                                                    Fetching current markup...
                                                </div>
                                            ) : (() => {
                                                const isUnchanged = markupType === currentMarkup.type && markupValue === currentMarkup.value;
                                                
                                                return (
                                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                                                        <div>
                                                            <label className="block text-xs font-medium text-gray-600 mb-1">Markup Type</label>
                                                            <select 
                                                                value={markupType} 
                                                                onChange={(e) => setMarkupType(e.target.value)}
                                                                className="w-full border border-gray-300 rounded-xl px-3 py-2.5 focus:ring-2 focus:ring-purple-500 outline-none text-sm"
                                                            >
                                                                <option value="FLAT">FLAT</option>
                                                                <option value="PERCENTAGE">PERCENTAGE</option>
                                                            </select>
                                                        </div>
                                                        <div>
                                                            <label className="block text-xs font-medium text-gray-600 mb-1">Markup Value</label>
                                                            <input 
                                                                type="number" 
                                                                placeholder="Enter value" 
                                                                value={markupValue}
                                                                onChange={(e) => setMarkupValue(e.target.value)}
                                                                className="w-full border border-gray-300 rounded-xl px-3 py-2.5 focus:ring-2 focus:ring-purple-500 outline-none text-sm" 
                                                            />
                                                        </div>
                                                        <div className="flex flex-col justify-end">
                                                            {isUnchanged && currentMarkup.value !== "" && (
                                                                <span className="text-[10px] text-amber-600 mb-1 font-semibold text-center w-full">
                                                                    Cannot update identical value
                                                                </span>
                                                            )}
                                                            <button 
                                                                onClick={handleUpdateMarkup}
                                                                disabled={markupLoading || markupValue === "" || isUnchanged}
                                                                className="w-full h-[42px] bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 disabled:opacity-50 text-white font-semibold rounded-xl shadow-sm transition-all text-sm"
                                                            >
                                                                {markupLoading ? "Updating..." : "Update Markup"}
                                                            </button>
                                                        </div>
                                                    </div>
                                                );
                                            })()}
                                        </div>
                                    </div>
                                )}


                                {/* OD MANAGEMENT */}
                                {/* {role === "SUPER_ONBOARDING" && (
                                    <div className="border-t mt-6 pt-6">
                                        <div className="bg-gradient-to-r from-amber-50 to-orange-50 border border-amber-100 rounded-2xl p-5">
                                            <div className="flex items-center justify-between mb-4">
                                                <div>
                                                    <h3 className="text-base font-bold text-gray-800">Overdraft (OD) Management</h3>
                                                    <p className="text-xs text-gray-500 mt-0.5">Configure OD credit line for this merchant</p>
                                                </div>
                                                {odData && (
                                                    <span className={`px-3 py-1 rounded-full text-xs font-bold ${
                                                        odData.isOdEnabled
                                                            ? odData.status === "BLOCKED"
                                                                ? "bg-amber-100 text-amber-700"
                                                                : "bg-green-100 text-green-700"
                                                            : "bg-red-100 text-red-700"
                                                    }`}>
                                                        {odData.isOdEnabled ? "ENABLED" : "DISABLED"}
                                                    </span>
                                                )}
                                            </div>

                                            {odLoading ? (
                                                <div className="flex items-center gap-2 text-gray-500 text-sm py-3">
                                                    <div className="w-4 h-4 border-2 border-amber-400 border-t-transparent rounded-full animate-spin"></div>
                                                    Loading OD data...
                                                </div>
                                            ) : !odData?.isOdEnabled ? (
                                                <>
                                                    <div className="bg-amber-50 border border-amber-200 rounded-xl p-3 mb-4 text-sm text-amber-700">
                                                        OD is currently <strong>disabled</strong> for this user. Fill the details below to enable.
                                                    </div>
                                                    <div className="grid grid-cols-1 md:grid-cols-5 gap-3">
                                                        <div>
                                                            <label className="block text-xs font-medium text-gray-600 mb-1">Credit Limit (₹)</label>
                                                            <input type="number" placeholder="e.g. 50000" value={odCreditLimit}
                                                                onChange={(e) => setOdCreditLimit(e.target.value)}
                                                                className="w-full border border-gray-300 rounded-xl px-3 py-2.5 focus:ring-2 focus:ring-amber-500 outline-none text-sm" />
                                                        </div>
                                                        <div>
                                                            <label className="block text-xs font-medium text-gray-600 mb-1">
                                                                Penalty {odPenaltyType === "PERCENTAGE" ? "(%)" : "(₹)"}
                                                            </label>
                                                            <input type="number" placeholder="e.g. 2" value={odPenalty}
                                                                onChange={(e) => setOdPenalty(e.target.value)}
                                                                className="w-full border border-gray-300 rounded-xl px-3 py-2.5 focus:ring-2 focus:ring-amber-500 outline-none text-sm" />
                                                        </div>
                                                        <div>
                                                            <label className="block text-xs font-medium text-gray-600 mb-1">Penalty Type</label>
                                                            <select value={odPenaltyType} onChange={(e) => setOdPenaltyType(e.target.value)}
                                                                className="w-full border border-gray-300 rounded-xl px-3 py-2.5 focus:ring-2 focus:ring-amber-500 outline-none text-sm">
                                                                <option value="FLAT">FLAT</option>
                                                                <option value="PERCENTAGE">PERCENTAGE</option>
                                                            </select>
                                                        </div>
                                                        <div>
                                                            <label className="block text-xs font-medium text-gray-600 mb-1">Remarks</label>
                                                            <input type="text" placeholder="Enter remarks" value={odRemarks}
                                                                onChange={(e) => setOdRemarks(e.target.value)}
                                                                className="w-full border border-gray-300 rounded-xl px-3 py-2.5 focus:ring-2 focus:ring-amber-500 outline-none text-sm" />
                                                        </div>
                                                        <div className="flex items-end">
                                                            <button
                                                                onClick={handleOdEnable}
                                                                disabled={odActionLoading}
                                                                className="w-full h-[42px] bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 disabled:opacity-50 text-white font-semibold rounded-xl shadow-sm transition-all text-sm flex items-center justify-center gap-2">
                                                                {odActionLoading ? (
                                                                    <>
                                                                        <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin inline-block" />
                                                                        Enabling...
                                                                    </>
                                                                ) : "Enable OD"}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    <div className="grid grid-cols-3 gap-3 mb-4">
                                                        <div className="bg-white rounded-xl p-3 border text-center">
                                                            <p className="text-xs text-gray-400 font-medium">Credit Limit</p>
                                                            <p className="text-base font-bold text-gray-800 mt-0.5">₹ {Number(odData.creditLimit).toLocaleString("en-IN")}</p>
                                                        </div>
                                                        <div className="bg-white rounded-xl p-3 border text-center">
                                                            <p className="text-xs text-gray-400 font-medium">Utilized</p>
                                                            <p className="text-base font-bold text-red-600 mt-0.5">₹ {Number(odData.utilizedAmount).toLocaleString("en-IN")}</p>
                                                        </div>
                                                        <div className="bg-white rounded-xl p-3 border text-center">
                                                            <p className="text-xs text-gray-400 font-medium">Available</p>
                                                            <p className="text-base font-bold text-green-600 mt-0.5">₹ {Number(odData.availableLimit).toLocaleString("en-IN")}</p>
                                                        </div>
                                                    </div>
                                                    {odData.lastDrawDate && (
                                                        <p className="text-xs text-gray-400 mb-3">Last Draw: {odData.lastDrawDate}</p>
                                                    )}
                                                    <div className="grid grid-cols-1 md:grid-cols-6 gap-3">
                                                        <div>
                                                            <label className="block text-xs font-medium text-gray-600 mb-1">Credit Limit (₹)</label>
                                                            <input type="number" value={odCreditLimit} onChange={(e) => setOdCreditLimit(e.target.value)}
                                                                className="w-full border border-gray-300 rounded-xl px-3 py-2.5 focus:ring-2 focus:ring-amber-500 outline-none text-sm" />
                                                        </div>
                                                        <div>
                                                            <label className="block text-xs font-medium text-gray-600 mb-1">
                                                                Penalty {odPenaltyType === "PERCENTAGE" ? "(%)" : "(₹)"}
                                                            </label>
                                                            <input type="number" value={odPenalty} onChange={(e) => setOdPenalty(e.target.value)}
                                                                className="w-full border border-gray-300 rounded-xl px-3 py-2.5 focus:ring-2 focus:ring-amber-500 outline-none text-sm" />
                                                        </div>
                                                        <div>
                                                            <label className="block text-xs font-medium text-gray-600 mb-1">Penalty Type</label>
                                                            <select value={odPenaltyType} onChange={(e) => setOdPenaltyType(e.target.value)}
                                                                className="w-full border border-gray-300 rounded-xl px-3 py-2.5 focus:ring-2 focus:ring-amber-500 outline-none text-sm">
                                                                <option value="FLAT">FLAT</option>
                                                                <option value="PERCENTAGE">PERCENTAGE</option>
                                                            </select>
                                                        </div>
                                                        <div>
                                                            <label className="block text-xs font-medium text-gray-600 mb-1">Remarks</label>
                                                            <input type="text" placeholder="Enter remarks" value={odRemarks}
                                                                onChange={(e) => setOdRemarks(e.target.value)}
                                                                className="w-full border border-gray-300 rounded-xl px-3 py-2.5 focus:ring-2 focus:ring-amber-500 outline-none text-sm" />
                                                        </div>
                                                        <div className="flex items-end gap-2 col-span-2">
                                                            <button
                                                                onClick={() => {
                                                                    if (!odCreditLimit || Number(odCreditLimit) <= 0) { showOdToast("error", "Please enter a valid credit limit"); return; }
                                                                    if (!odRemarks?.trim()) { showOdToast("error", "Remarks is required"); return; }
                                                                    setOdConfirmAction("UPDATE");
                                                                }}
                                                                disabled={odActionLoading}
                                                                className="flex-1 h-[42px] bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 disabled:opacity-50 text-white font-semibold rounded-xl shadow-sm transition-all text-sm">
                                                                {odActionLoading ? "Processing..." : "Update OD"}
                                                            </button>
                                                            {odData.status === "BLOCKED" && (
                                                                <button onClick={() => setOdConfirmAction("UNBLOCK")} disabled={odActionLoading}
                                                                    className="flex-1 h-[42px] bg-gradient-to-r from-blue-500 to-indigo-500 hover:from-blue-600 hover:to-indigo-600 disabled:opacity-50 text-white font-semibold rounded-xl shadow-sm transition-all text-sm">
                                                                    Unblock
                                                                </button>
                                                            )}
                                                            <button onClick={handleOdDisable} disabled={odActionLoading}
                                                                className="flex-1 h-[42px] bg-gradient-to-r from-red-500 to-rose-500 hover:from-red-600 hover:to-rose-600 disabled:opacity-50 text-white font-semibold rounded-xl shadow-sm transition-all text-sm flex items-center justify-center gap-2">
                                                                {odActionLoading ? (
                                                                    <>
                                                                        <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin inline-block" />
                                                                        Disabling...
                                                                    </>
                                                                ) : "Disable OD"}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                )} */}

                                {/* NEW: FULL OD & DOCUMENTATION INTEGRATION */}
                                {role === "SUPER_ONBOARDING" && (
                                    <div className="border-t mt-6 pt-6">
                                        <div className="bg-gradient-to-r from-amber-50 to-orange-50 border border-amber-100 rounded-2xl p-5">
                                            
                                            {/* Header */}
                                            <div className="flex items-center justify-between mb-5">
                                                <div>
                                                    <h3 className="text-base font-bold text-gray-800">OD Sanction & Management</h3>
                                                    <p className="text-xs text-gray-500 mt-0.5">Configure credit limits, penalties, and upload documents</p>
                                                </div>
                                                {odData && (
                                                    <span className={`px-3 py-1 rounded-full text-xs font-bold ${
                                                        odData.status === "ACTIVE" ? "bg-green-100 text-green-700 border border-green-200"
                                                        : odData.status === "BLOCKED" ? "bg-amber-100 text-amber-700 border border-amber-200"
                                                        : "bg-red-100 text-red-700 border border-red-200"
                                                    }`}>
                                                        {odData.status}
                                                    </span>
                                                )}
                                            </div>

                                            {odLoading ? (
                                                <div className="flex items-center gap-2 text-gray-500 text-sm py-4">
                                                    <div className="w-4 h-4 border-2 border-amber-400 border-t-transparent rounded-full animate-spin"></div>
                                                    Loading OD details...
                                                </div>
                                            ) : (
                                                <>
                                                    {/* Top Stat Bar - only if account exists */}
                                                    {odData && (
                                                        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-5">
                                                            <div className="bg-white rounded-xl p-3 border text-center shadow-sm">
                                                                <p className="text-xs text-gray-400 font-medium">Sanctioned Limit</p>
                                                                <p className="text-[15px] font-bold text-gray-800 mt-0.5">₹ {Number(odData.sanctionedAmount || 0).toLocaleString("en-IN")}</p>
                                                            </div>
                                                            <div className="bg-white rounded-xl p-3 border text-center shadow-sm">
                                                                <p className="text-xs text-gray-400 font-medium">Usable Credit Limit</p>
                                                                <p className="text-[15px] font-bold text-gray-800 mt-0.5">₹ {Number(odData.creditLimit || 0).toLocaleString("en-IN")}</p>
                                                            </div>
                                                            <div className="bg-white rounded-xl p-3 border text-center shadow-sm">
                                                                <p className="text-xs text-gray-400 font-medium">Utilized</p>
                                                                <p className="text-[15px] font-bold text-red-600 mt-0.5">₹ {Number(odData.utilizedAmount || 0).toLocaleString("en-IN")}</p>
                                                            </div>
                                                            <div className="bg-white rounded-xl p-3 border text-center shadow-sm">
                                                                <p className="text-xs text-gray-400 font-medium">Available</p>
                                                                <p className="text-[15px] font-bold text-green-600 mt-0.5">₹ {Number(odData.availableLimit || 0).toLocaleString("en-IN")}</p>
                                                            </div>
                                                        </div>
                                                    )}

                                                    {/* Warning block if disabled */}
                                                    {odData?.status === "DISABLED" && (
                                                        <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-xl text-sm mb-5">
                                                            <strong>Note:</strong> This OD account is currently disabled. 
                                                        </div>
                                                    )}

                                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-2">
                                                        {/* Left Side: Settings/Forms */}
                                                        <div className="space-y-3">
                                                            <div className="grid grid-cols-2 gap-3">
                                                                <div>
                                                                    <label className="block text-xs font-medium text-gray-600 mb-1">Sanctioned (₹)</label>
                                                                    <input type="number" placeholder="e.g. 100000" value={odSanctionedAmount} onChange={(e) => setOdSanctionedAmount(e.target.value)}
                                                                        className="w-full border border-gray-300 bg-white rounded-xl px-3 py-2 text-sm focus:ring-2 focus:ring-amber-500 outline-none" />
                                                                </div>
                                                                <div>
                                                                    <label className="block text-xs font-medium text-gray-600 mb-1">Usable Limit (₹)</label>
                                                                    <input type="number" placeholder="e.g. 50000" value={odCreditLimit} onChange={(e) => setOdCreditLimit(e.target.value)}
                                                                        className="w-full border border-gray-300 bg-white rounded-xl px-3 py-2 text-sm focus:ring-2 focus:ring-amber-500 outline-none" />
                                                                </div>
                                                            </div>
                                                            <div className="grid grid-cols-2 gap-3">
                                                                <div>
                                                                    <label className="block text-xs font-medium text-gray-600 mb-1">Penalty {odPenaltyType === "PERCENTAGE" ? "(%)" : "(₹)"}</label>
                                                                    <input type="number" placeholder="e.g. 2" value={odPenalty} onChange={(e) => setOdPenalty(e.target.value)}
                                                                        className="w-full border border-gray-300 bg-white rounded-xl px-3 py-2 text-sm focus:ring-2 focus:ring-amber-500 outline-none" />
                                                                </div>
                                                                <div>
                                                                    <label className="block text-xs font-medium text-gray-600 mb-1">Penalty Type</label>
                                                                    <select value={odPenaltyType} onChange={(e) => setOdPenaltyType(e.target.value)}
                                                                        className="w-full border border-gray-300 bg-white rounded-xl px-3 py-2 text-sm focus:ring-2 focus:ring-amber-500 outline-none">
                                                                        <option value="FLAT">FLAT</option>
                                                                        <option value="PERCENTAGE">PERCENTAGE</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <label className="block text-xs font-medium text-gray-600 mb-1">Remarks</label>
                                                                <input type="text" placeholder="Update remarks..." value={odRemarks} onChange={(e) => setOdRemarks(e.target.value)}
                                                                    className="w-full border border-gray-300 bg-white rounded-xl px-3 py-2 text-sm focus:ring-2 focus:ring-amber-500 outline-none" />
                                                            </div>

                                                            <div>
                                                                <label className="block text-xs font-medium text-gray-600 mb-1">MPIN <span className="text-red-500">*</span></label>
                                                                <input
                                                                    type="password"
                                                                    maxLength={6}
                                                                    value={odMpin}
                                                                    onChange={(e) => setOdMpin(e.target.value.replace(/\D/g, ""))}
                                                                    placeholder="Enter MPIN"
                                                                    className="w-full border border-gray-300 bg-white rounded-xl px-3 py-2 text-sm focus:ring-2 focus:ring-amber-500 outline-none tracking-widest text-center font-semibold"
                                                                />
                                                            </div>

                                                            <div className="flex flex-wrap gap-2 pt-2">
    {/* Dynamic Buttons based on Account existence & status */}
    {!odData?.isOdEnabled ? (
        <button 
            onClick={handleOdEnable} 
            disabled={odActionLoading}
            className="flex-1 bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600 text-white font-semibold py-2 rounded-xl text-sm transition-all shadow-sm flex items-center justify-center gap-2"
        >
            {odActionLoading ? "Processing..." : (
                <>
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7"></path>
                    </svg>
                    Approve & Enable OD
                </>
            )}
        </button>
    ) : (
        <>
            <button 
                onClick={() => {
                    if (!odCreditLimit || Number(odCreditLimit) <= 0) { showOdToast("error", "Please enter a valid credit limit"); return; }
                    if (!odRemarks?.trim()) { showOdToast("error", "Remarks is required"); return; }
                    setOdConfirmAction("UPDATE");
                }} 
                disabled={odActionLoading}
                className="flex-1 bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white font-semibold py-2 px-3 rounded-xl text-sm transition-all shadow-sm"
            >
                Update OD
            </button>

            {odData.status === "BLOCKED" && (
                <button 
                    onClick={() => setOdConfirmAction("UNBLOCK")} 
                    disabled={odActionLoading}
                    className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded-xl text-sm transition-all shadow-sm"
                >
                    Unblock
                </button>
            )}

            <button 
                onClick={handleOdDisable} 
                disabled={odActionLoading}
                className="bg-red-500 hover:bg-red-600 text-white font-semibold py-2 px-4 rounded-xl text-sm transition-all shadow-sm"
            >
                Disable OD
            </button>
        </>
    )}
</div>
                                                        </div>

                                                        {/* Right Side: Documents Viewer & Uploader */}
                                                        <div className="flex flex-col h-full">
                                                            {!odData ? (
                                                                <div className="border border-dashed border-amber-300 bg-amber-50/50 rounded-xl h-full flex flex-col items-center justify-center text-center p-6 text-amber-700">
                                                                    <svg className="w-8 h-8 mb-2 opacity-50" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path></svg>
                                                                    <p className="text-sm font-medium">No OD Account</p>
                                                                    <p className="text-xs mt-1 opacity-75">Create an account first to manage documents.</p>
                                                                </div>
                                                            ) : (
                                                                <div className="border border-amber-200 bg-amber-100/30 rounded-xl p-3 flex flex-col h-full">
                                                                    <h4 className="text-sm font-semibold text-gray-700 mb-3 px-1">OD Documents</h4>
                                                                    
                                                                    <div className="flex-1 space-y-2 overflow-y-auto max-h-[160px] pr-1 mb-4 scrollbar-thin">
                                                                        {(odData.documents && odData.documents.length > 0) ? (
                                                                            odData.documents.map((doc, idx) => (
                                                                                <div key={idx} className="flex items-center justify-between bg-white border border-gray-200 rounded-lg p-2.5 shadow-sm">
                                                                                    <div className="flex flex-col min-w-0 pr-2">
                                                                                        <span className="text-sm text-gray-800 font-semibold truncate">{doc.label}</span>
                                                                                        <span className="text-[11px] text-gray-500 truncate mt-0.5">By {doc.uploadedBy || "System"} • {new Date(doc.uploadedAt).toLocaleDateString("en-IN")}</span>
                                                                                    </div>
                                                                                    <a href={doc.url} target="_blank" rel="noreferrer" 
                                                                                        className="text-xs bg-indigo-50 text-indigo-700 px-3 py-1.5 rounded-md font-medium hover:bg-indigo-100 transition-colors whitespace-nowrap shrink-0">
                                                                                        View
                                                                                    </a>
                                                                                </div>
                                                                            ))
                                                                        ) : (
                                                                            <div className="text-xs text-gray-500 text-center py-4 bg-white/50 rounded-lg border border-dashed border-gray-300">
                                                                                No documents uploaded yet.
                                                                            </div>
                                                                        )}
                                                                    </div>

                                                                    {/* Uploader Form */}
                                                                    <div className="bg-white p-3 rounded-xl border shadow-sm mt-auto">
                                                                        <p className="text-xs font-semibold text-gray-600 mb-2">Upload New Document</p>
                                                                        <div className="flex flex-col gap-2">
                                                                            <input type="text" placeholder="Label (e.g. Agreement, Cheque)" value={docLabel} onChange={(e) => setDocLabel(e.target.value)}
                                                                                className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-amber-500 outline-none" />
                                                                            <div className="flex items-center gap-2">
                                                                                <input 
                                                                                    id="odFileInput" // 👈 IMPORTANT FOR CLEARING
                                                                                    type="file" 
                                                                                    onChange={(e) => setDocFile(e.target.files[0])}
                                                                                    className="flex-1 text-xs text-gray-600 file:mr-2 file:py-1.5 file:px-3 file:rounded-lg file:border-0 file:font-semibold file:bg-amber-50 file:text-amber-700 hover:file:bg-amber-100 cursor-pointer" 
                                                                                />
                                                                                <button onClick={handleUploadDocument} disabled={docUploading || !docFile || !docLabel.trim()}
                                                                                    className="bg-amber-600 hover:bg-amber-700 disabled:opacity-50 text-white text-xs font-semibold px-4 py-2 rounded-lg transition-colors whitespace-nowrap shrink-0">
                                                                                    {docUploading ? "Uploading..." : "Upload"}
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                )}

                     

                                {/* LIEN AMOUNT MANAGEMENT */}
                                {role === "SUPER_ONBOARDING" && (
                                    <div className="border-t mt-6 pt-6">
                                        <div className="bg-gradient-to-r from-indigo-50 to-blue-50 border border-indigo-100 rounded-2xl p-5">
                                            <div className="flex items-center justify-between mb-4">
                                                <div>
                                                    <h3 className="text-base font-bold text-gray-800">Lien Amount Management</h3>
                                                    <p className="text-xs text-gray-500 mt-0.5">Block or release a portion of the merchant wallet balance</p>
                                                </div>
                                            </div>

                                      
                                            <div className="flex gap-2 mb-4">
                                                {["ADD", "SUB", "UNHOLD"].map((m) => (
                                                    <button key={m} onClick={() => { setLienMode(m); setLienAmount(""); }}
                                                        className={`px-4 py-1.5 rounded-full text-xs font-semibold border transition-all ${lienMode === m
                                                            ? m === "ADD" ? "bg-indigo-600 text-white border-indigo-600"
                                                                : m === "SUB" ? "bg-blue-600 text-white border-blue-600"
                                                                    : "bg-green-600 text-white border-green-600"
                                                            : "bg-white text-gray-600 border-gray-300 hover:bg-gray-50"}`}>
                                                        {m === "ADD" ? "Add Lien" : m === "SUB" ? "Subtract Lien" : "Release (Unhold)"}
                                                    </button>
                                                ))}
                                            </div>

                                            <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
                                                {lienMode !== "UNHOLD" && (
                                                    <div>
                                                        <label className="block text-xs font-medium text-gray-600 mb-1">Amount (₹)</label>
                                                        <input type="number" placeholder="e.g. 500" value={lienAmount}
                                                            onChange={(e) => setLienAmount(e.target.value)}
                                                            className="w-full border border-gray-300 rounded-xl px-3 py-2.5 focus:ring-2 focus:ring-indigo-500 outline-none text-sm" />
                                                    </div>
                                                )}
                                                <div>
                                                    <label className="block text-xs font-medium text-gray-600 mb-1">Reason</label>
                                                    <input type="text" placeholder="e.g. Security deposit" value={lienReason}
                                                        onChange={(e) => setLienReason(e.target.value)}
                                                        className="w-full border border-gray-300 rounded-xl px-3 py-2.5 focus:ring-2 focus:ring-indigo-500 outline-none text-sm" />
                                                </div>
                                                <div>
                                                    <label className="block text-xs font-medium text-gray-600 mb-1">Remark</label>
                                                    <input type="text" placeholder="e.g. Account verification hold" value={lienRemark}
                                                        onChange={(e) => setLienRemark(e.target.value)}
                                                        className="w-full border border-gray-300 rounded-xl px-3 py-2.5 focus:ring-2 focus:ring-indigo-500 outline-none text-sm" />
                                                </div>
                                                <div className="flex items-end">
                                                    <button
                                                        onClick={() => {
                                                            if (lienMode !== "UNHOLD" && (!lienAmount || Number(lienAmount) <= 0)) {
                                                                setResultPopup({ status: "FAILED", message: "Please enter a valid lien amount" });
                                                                return;
                                                            }
                                                            if (!lienReason.trim()) {
                                                                setResultPopup({ status: "FAILED", message: "Reason is required" });
                                                                return;
                                                            }
                                                            setLienConfirm(true);
                                                        }}
                                                        disabled={lienLoading}
                                                        className={`w-full h-[42px] text-white font-semibold rounded-xl shadow-sm transition-all text-sm disabled:opacity-50 ${lienMode === "ADD"
                                                            ? "bg-gradient-to-r from-indigo-500 to-blue-500 hover:from-indigo-600 hover:to-blue-600"
                                                            : lienMode === "SUB"
                                                                ? "bg-gradient-to-r from-blue-500 to-cyan-500 hover:from-blue-600 hover:to-cyan-600"
                                                                : "bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600"}`}>
                                                        {lienLoading ? "Processing..." : lienMode === "ADD" ? "Add Lien" : lienMode === "SUB" ? "Subtract Lien" : "Release Lien"}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                            </div>
                        </div>

                        {/* LIEN HISTORY (Super Admin only) */}
                        {role === "SUPER_ONBOARDING" && (lienHistLoading || lienHistData) && (
                            <div className="bg-white rounded-2xl shadow border overflow-hidden">
                                {/* Header */}
                                <div className="px-5 py-4 border-b bg-gradient-to-r from-indigo-50 to-blue-50">
                                    <h3 className="text-base font-bold text-gray-800">Lien History</h3>
                                </div>

                                {/* Loading */}
                                {lienHistLoading && (
                                    <div className="flex flex-col items-center gap-3 py-12">
                                        <div className="w-8 h-8 border-4 border-[#0A2A4F] border-t-transparent rounded-full animate-spin"></div>
                                        <p className="text-gray-400 text-sm">Fetching lien data...</p>
                                    </div>
                                )}

                                {/* Summary + Table */}
                                {!lienHistLoading && lienHistData && (() => {
                                    const lhTH = "border border-[#94A3B8] bg-[#EFF6FF] px-3 py-2.5 text-left text-[11px] font-medium text-[#0A2A4F] uppercase tracking-wider whitespace-nowrap select-none";
                                    const lhTD = "border border-[#94A3B8] px-3 py-2.5 text-sm text-gray-700 align-middle whitespace-nowrap";
                                    const lhTDW = "border border-[#94A3B8] px-3 py-2.5 text-sm text-gray-700 align-middle break-words whitespace-normal";
                                    const history = lienHistData.history ?? [];
                                    const lhStatus = String(lienHistData.status ?? "").toUpperCase();
                                    const lhStatusCfg = {
                                        HOLD: "bg-amber-100 text-amber-700 border-amber-200",
                                        UNHOLD: "bg-green-100 text-green-700 border-green-200",
                                        RELEASED: "bg-blue-100 text-blue-700 border-blue-200",
                                    };
                                    const lhBadge = lhStatusCfg[lhStatus] || "bg-gray-100 text-gray-600 border-gray-200";
                                    return (
                                        <>
                                            {/* Summary bar */}
                                            <div className="px-5 py-3 border-b flex flex-wrap gap-4 items-center bg-white">
                                                <div className="flex items-center gap-2">
                                                    <span className="text-xs text-gray-500 font-medium">MID:</span>
                                                    <span className="text-sm font-semibold text-gray-800">{lienHistData.mid ?? "-"}</span>
                                                </div>
                                                <div className="flex items-center gap-2">
                                                    <span className="text-xs text-gray-500 font-medium">Mobile:</span>
                                                    <span className="text-sm font-semibold text-gray-800">{lienHistData.mobileNumber ?? "-"}</span>
                                                </div>
                                                <div className="flex items-center gap-2">
                                                    <span className="text-xs text-gray-500 font-medium">Lien Amount:</span>
                                                    <span className="text-sm font-bold text-red-600">{lienHistFmt(lienHistData.lienAmount)}</span>
                                                </div>
                                                <div className="flex items-center gap-2">
                                                    <span className="text-xs text-gray-500 font-medium">Status:</span>
                                                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-lg text-xs font-semibold border ${lhBadge}`}>
                                                        {lienHistData.status ?? "-"}
                                                    </span>
                                                </div>
                                                <div className="flex items-center gap-2 ml-auto">
                                                    <span className="text-xs text-gray-400">{history.length} record{history.length !== 1 ? "s" : ""}</span>
                                                </div>
                                            </div>

                                            {/* Table */}
                                            <div className="overflow-x-auto">
                                                <table className="border-collapse text-sm" style={{ minWidth: 1200, width: "100%" }}>
                                                    <thead>
                                                        <tr>
                                                            <th className={lhTH}>#</th>
                                                            <th className={lhTH}>Lien ID</th>
                                                            <th className={lhTH}>Mode</th>
                                                            <th className={lhTH}>Txn Amount</th>
                                                            <th className={lhTH}>Lien Amount</th>
                                                            <th className={lhTH}>Status</th>
                                                            <th className={lhTH}>Remark</th>
                                                            <th className={lhTH}>Reason</th>
                                                            <th className={lhTH}>Modified By</th>
                                                            <th className={lhTH} style={{ width: 96, whiteSpace: "normal" }}>Merchant Wallet Bal.</th>
                                                            <th className={lhTH} style={{ width: 80, whiteSpace: "normal" }}>AEPS Wallet Bal.</th>
                                                            <th className={lhTH}>Created At</th>
                                                            <th className={lhTH}>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {history.length === 0 ? (
                                                            <tr>
                                                                <td colSpan={13} className="border border-[#94A3B8] py-12 text-center">
                                                                    <div className="flex flex-col items-center gap-2">
                                                                        <div className="w-12 h-12 rounded-2xl bg-gray-100 flex items-center justify-center text-2xl">📭</div>
                                                                        <p className="text-gray-500 text-sm font-medium">No history records</p>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ) : (
                                                            history.map((row, idx) => {
                                                                const rowStatus = String(row.status ?? "").toUpperCase();
                                                                const rowCfg = {
                                                                    HOLD: "bg-amber-100 text-amber-700 border-amber-200",
                                                                    UNHOLD: "bg-green-100 text-green-700 border-green-200",
                                                                    RELEASED: "bg-blue-100 text-blue-700 border-blue-200",
                                                                };
                                                                const rowBadge = rowCfg[rowStatus] || "bg-gray-100 text-gray-600 border-gray-200";
                                                                return (
                                                                    <tr key={row.lienId ?? idx} className={idx % 2 === 0 ? "bg-white" : "bg-[#F8FAFC]"}>
                                                                        <td className={lhTD}>{idx + 1}</td>
                                                                        <td className={lhTD}>{row.lienId ?? "-"}</td>
                                                                        <td className={lhTD}>
                                                                            <span className={`inline-flex items-center px-2.5 py-0.5 rounded-lg text-xs font-semibold border ${row.mode === "ADD" ? "bg-indigo-100 text-indigo-700 border-indigo-200" : row.mode === "SUB" ? "bg-orange-100 text-orange-700 border-orange-200" : "bg-green-100 text-green-700 border-green-200"}`}>
                                                                                {row.mode ?? "-"}
                                                                            </span>
                                                                        </td>
                                                                        <td className={lhTD}>{lienHistFmt(row.txnAmount)}</td>
                                                                        <td className={`${lhTD} font-semibold text-red-600`}>{lienHistFmt(row.lienAmount)}</td>
                                                                        <td className={lhTD}>
                                                                            <span className={`inline-flex items-center px-2.5 py-0.5 rounded-lg text-xs font-semibold border ${rowBadge}`}>
                                                                                {row.status ?? "-"}
                                                                            </span>
                                                                        </td>
                                                                        <td className={lhTDW} style={{ minWidth: 120, maxWidth: 200 }}>{row.remark ?? "-"}</td>
                                                                        <td className={lhTDW} style={{ minWidth: 120, maxWidth: 200 }}>{row.reason ?? "-"}</td>
                                                                        <td className={lhTD}>{row.modifiedBy ?? "-"}</td>
                                                                        <td className={lhTD} style={{ width: 96 }}>{lienHistFmt(row.merchantWalletBalance)}</td>
                                                                        <td className={lhTD} style={{ width: 80 }}>{lienHistFmt(row.aepsWalletBalance)}</td>
                                                                        <td className={lhTD}>
                                                                            {row.createdAt
                                                                                ? new Date(row.createdAt).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" })
                                                                                : "-"}
                                                                        </td>
                                                                        <td className={lhTD}>
                                                                            <button
                                                                                onClick={() => openLienEditModal(row)}
                                                                                className="inline-flex items-center gap-1.5 bg-[#0A2A4F] hover:bg-[#0d3566] text-white text-xs font-semibold px-3 py-1.5 rounded-lg transition-colors whitespace-nowrap"
                                                                            >
                                                                                ✎ Edit
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </>
                                    );
                                })()}
                            </div>
                        )}

                        {/* CDM HISTORY */}
                        {(cdmHistLoading || cdmHistData) && (
                            <div className="bg-white rounded-2xl shadow border overflow-hidden">
                                {/* Header */}
                                <div className="px-5 py-4 border-b bg-gradient-to-r from-teal-50 to-cyan-50 flex items-center justify-between">
                                    <h3 className="text-base font-bold text-gray-800">CDM Card Mapping History</h3>
                                    {!cdmHistLoading && cdmHistData && (
                                        <button
                                            onClick={() => fetchCdmHistory(userData?.username)}
                                            className="text-xs text-teal-700 hover:text-teal-900 font-semibold px-3 py-1.5 rounded-lg border border-teal-200 bg-white hover:bg-teal-50 transition"
                                        >
                                            ↻ Refresh
                                        </button>
                                    )}
                                </div>

                                {/* Loading */}
                                {cdmHistLoading && (
                                    <div className="flex flex-col items-center gap-3 py-12">
                                        <div className="w-8 h-8 border-4 border-teal-600 border-t-transparent rounded-full animate-spin"></div>
                                        <p className="text-gray-400 text-sm">Fetching CDM data...</p>
                                    </div>
                                )}

                                {/* Table */}
                                {!cdmHistLoading && cdmHistData && (() => {
                                    const cdmTH = "border border-[#94A3B8] bg-[#F0FDFA] px-3 py-2.5 text-left text-[11px] font-medium text-teal-900 uppercase tracking-wider whitespace-nowrap select-none";
                                    const cdmTD = "border border-[#94A3B8] px-3 py-2.5 text-sm text-gray-700 align-middle whitespace-nowrap";

                                    const records = Array.isArray(cdmHistData)
                                        ? cdmHistData
                                        : Array.isArray(cdmHistData?.data)
                                            ? cdmHistData.data
                                            : Array.isArray(cdmHistData?.cardMappings)
                                                ? cdmHistData.cardMappings
                                                : Array.isArray(cdmHistData?.content)
                                                    ? cdmHistData.content
                                                    : [];

                                    return (
                                        <>
                                            {/* Summary bar */}
                                            <div className="px-5 py-3 border-b flex flex-wrap gap-4 items-center bg-white">
                                                <div className="flex items-center gap-2">
                                                    <span className="text-xs text-gray-500 font-medium">MID:</span>
                                                    <span className="text-sm font-semibold text-gray-800">{userData?.username ?? "-"}</span>
                                                </div>
                                                <div className="flex items-center gap-2 ml-auto">
                                                    <span className="text-xs text-gray-400">{records.length} record{records.length !== 1 ? "s" : ""}</span>
                                                </div>
                                            </div>

                                            {/* Table */}
                                            <div className="overflow-x-auto">
                                                <table className="border-collapse text-sm" style={{ minWidth: 1000, width: "100%" }}>
                                                    <thead>
                                                        <tr>
                                                            <th className={cdmTH}>#</th>
                                                            <th className={cdmTH}>CDM Card No</th>
                                                            <th className={cdmTH}>Agent Emboss Code</th>
                                                            <th className={cdmTH}>Status</th>
                                                            <th className={cdmTH}>Created At</th>
                                                            <th className={cdmTH}>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {records.length === 0 ? (
                                                            <tr>
                                                                <td colSpan={6} className="border border-[#94A3B8] py-12 text-center">
                                                                    <div className="flex flex-col items-center gap-2">
                                                                        <div className="w-12 h-12 rounded-2xl bg-gray-100 flex items-center justify-center text-2xl">📭</div>
                                                                        <p className="text-gray-500 text-sm font-medium">No CDM records found</p>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ) : (
                                                            records.map((row, idx) => {
                                                                const isActive = row.active === true;
                                                                const cardNo = row.cdmCardNo ?? "";
                                                                const isDeactivating = cdmDeactivatingId === cardNo;
                                                                const isReactivating = cdmReactivatingId === cardNo;
                                                                return (
                                                                    <tr key={row.id ?? idx} className={idx % 2 === 0 ? "bg-white" : "bg-[#F0FDFA]"}>
                                                                        <td className={cdmTD}>{row.id ?? idx + 1}</td>
                                                                        <td className={`${cdmTD} font-mono font-semibold text-gray-900`}>{cardNo || "-"}</td>
                                                                        <td className={cdmTD}>{row.agentEmbossCode ?? "-"}</td>
                                                                        <td className={cdmTD}>
                                                                            <span className={`inline-flex items-center px-2.5 py-0.5 rounded-lg text-xs font-semibold border ${isActive ? "bg-green-100 text-green-700 border-green-200" : "bg-red-100 text-red-700 border-red-200"}`}>
                                                                                {isActive ? "Active" : "Inactive"}
                                                                            </span>
                                                                        </td>
                                                                        <td className={cdmTD}>
                                                                            {row.createdAt
                                                                                ? new Date(row.createdAt).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" })
                                                                                : "-"}
                                                                        </td>
                                                                        <td className={cdmTD}>
                                                                            {isActive ? (
                                                                                <button
                                                                                    onClick={() => cardNo && handleCdmDeactivate(cardNo)}
                                                                                    disabled={isDeactivating || !cardNo}
                                                                                    className="inline-flex items-center gap-1.5 bg-red-600 hover:bg-red-700 disabled:opacity-60 disabled:cursor-not-allowed text-white text-xs font-semibold px-3 py-1.5 rounded-lg transition-colors whitespace-nowrap"
                                                                                >
                                                                                    {isDeactivating ? (
                                                                                        <>
                                                                                            <span className="w-3 h-3 border-2 border-white border-t-transparent rounded-full animate-spin inline-block" />
                                                                                            Deactivating...
                                                                                        </>
                                                                                    ) : "Deactivate"}
                                                                                </button>
                                                                            ) : (
                                                                                <button
                                                                                    onClick={() => cardNo && handleCdmReactivate(cardNo)}
                                                                                    disabled={isReactivating || !cardNo}
                                                                                    className="inline-flex items-center gap-1.5 bg-green-600 hover:bg-green-700 disabled:opacity-60 disabled:cursor-not-allowed text-white text-xs font-semibold px-3 py-1.5 rounded-lg transition-colors whitespace-nowrap"
                                                                                >
                                                                                    {isReactivating ? (
                                                                                        <>
                                                                                            <span className="w-3 h-3 border-2 border-white border-t-transparent rounded-full animate-spin inline-block" />
                                                                                            Reactivating...
                                                                                        </>
                                                                                    ) : "Reactivate"}
                                                                                </button>
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </>
                                    );
                                })()}
                            </div>
                        )}

                        {/* CASH-IN + RECENT TXN */}
                        {userData?.username && <CashInHistory mid={userData.username} />}
                        {userData?.username && <RecentTransactions mid={userData.username} />}

                        {/* LEDGER TABS */}
                        {userData?.username && (
                            <div className="bg-white rounded-2xl shadow border p-4">
                                <p className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-3">Ledger Reports</p>
                                <div className="flex flex-wrap gap-2">
                                    {[
                                        { key: "MAIN", label: "Main Ledger", active: "bg-blue-600 text-white border-blue-600" },
                                        { key: "AEPS", label: "AEPS Ledger", active: "bg-green-600 text-white border-green-600" },
                                        { key: "COMMISSION", label: "Commission Ledger", active: "bg-purple-600 text-white border-purple-600" },
                                    ].map(({ key, label, active }) => (
                                        <button key={key} onClick={() => setActiveLedger(key)}
                                            className={`px-5 py-2 rounded-xl text-sm font-semibold border transition-all ${activeLedger === key ? active : "bg-gray-50 text-gray-600 border-gray-200 hover:bg-gray-100"}`}>
                                            {label}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        )}

                        {userData?.username && (
                            <>
                                {activeLedger === "MAIN" && <LedgerReport mid={userData.username} />}
                                {activeLedger === "AEPS" && <AepsLedgerReport mid={userData.username} />}
                                {activeLedger === "COMMISSION" && <CommissionLedgerReport mid={userData.username} />}
                            </>
                        )}

                        {/* SERVICE HISTORY CHIPS */}
                        {userData?.username && (
                            <div className="bg-white rounded-2xl shadow border p-4">
                                <p className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-3">Service History</p>
                                <div className="flex flex-wrap gap-2">
                                    {[
                                        { value: "", label: "All" },
                                        { value: "AEPS_HISTORY", label: "AEPS" },
                                        { value: "AEPS_SETTLEMENT", label: "Settlement" },
                                        { value: "RECHARGE", label: "Recharge" },
                                        { value: "BBPS", label: "BBPS" },
                                        { value: "DMT", label: "DMT" },
                                        { value: "CCBP", label: "CCBP" },
                                        { value: "PPI", label: "PPI" },
                                        { value: "PG", label: "PG" },
                                        { value: "OD_HISTORY", label: "OD History" },
                                    ].map(({ value, label }) => (
                                        <button key={value} onClick={() => setActiveService(value)}
                                            className={`px-4 py-1.5 rounded-full text-xs font-semibold border transition-all ${activeService === value
                                                    ? "bg-[#0A2A4F] text-white border-[#0A2A4F]"
                                                    : "bg-gray-50 text-gray-600 border-gray-200 hover:bg-gray-100"
                                                }`}>
                                            {label}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* SERVICE CONTENT */}
                        {userData?.username && (
                            <>
                                {activeService === "AEPS_SETTLEMENT" && <PayoutHistory mid={userData.username} />}
                                {activeService === "AEPS_HISTORY" && <div className="bg-white p-4 rounded-xl mt-4"><AepsHistory mid={userData.username} /></div>}
                                {activeService === "RECHARGE" && <div className="bg-white p-4 rounded-xl mt-4"><MobileRechargeHistory mid={userData.username} /></div>}
                                {activeService === "DMT" && <div className="bg-white p-4 rounded-xl mt-4"><DmtHistory mid={userData.username} /></div>}
                                {activeService === "CCBP" && <div className="bg-white p-4 rounded-xl mt-4"><CcbpHistory mid={userData.username} /></div>}
                                {activeService === "PPI" && <div className="bg-white p-4 rounded-xl mt-4"><PpiHistory mid={userData.username} /></div>}
                                {activeService === "PG" && <div className="bg-white p-4 rounded-xl mt-4"><PgHistory mid={userData.username} /></div>}
                                {activeService === "BBPS" && <div className="bg-white p-4 rounded-xl mt-4"><BbpHistory mid={userData.username} /></div>}
                                {activeService === "OD_HISTORY" && <OdHistory mid={userData.username} />}
                            </>
                        )}
                    </>
                ) : (
                    <div className="bg-white rounded-2xl shadow p-16 text-center">
                        <div className="text-5xl mb-4">🔍</div>
                        <h3 className="text-lg font-semibold text-gray-700">Search for a User</h3>
                        <p className="text-gray-400 text-sm mt-1">Enter mobile number, BP User ID or name above</p>
                    </div>
                )}
            </div>

            {/* OD TOAST */}
            {odToast && (
                <div className={`fixed top-5 right-5 z-[60] flex items-start gap-3 px-5 py-4 rounded-2xl shadow-xl border max-w-sm animate-fade-in ${
                    odToast.type === "success"
                        ? "bg-green-50 border-green-200 text-green-800"
                        : "bg-red-50 border-red-200 text-red-800"
                }`}>
                    <span className="text-lg leading-none mt-0.5 font-bold">
                        {odToast.type === "success" ? "✓" : "✕"}
                    </span>
                    <div className="flex-1 min-w-0">
                        <p className="font-semibold text-sm">
                            {odToast.type === "success" ? "Success" : "Error"}
                        </p>
                        <p className="text-xs mt-0.5 opacity-80 break-words">{odToast.message}</p>
                    </div>
                    <button
                        onClick={() => setOdToast(null)}
                        className="text-current opacity-40 hover:opacity-70 text-sm leading-none flex-shrink-0"
                    >
                        ✕
                    </button>
                </div>
            )}

            {/* REVERSAL CONFIRM MODAL */}
            {showConfirm && (
                <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
                    <div className="bg-white rounded-2xl p-6 w-[90%] max-w-md shadow-2xl">
                        <h2 className="text-lg font-bold mb-1 text-gray-800">Confirm Reversal</h2>
                        <p className="text-sm text-gray-500 mb-5">Are you sure you want to reverse <b>₹{amount}</b>?</p>
                        <div className="flex justify-end gap-3">
                            <button onClick={() => setShowConfirm(false)} className="px-5 py-2 rounded-xl bg-gray-100 text-gray-700 font-medium text-sm hover:bg-gray-200">Cancel</button>
                            <button onClick={confirmReversal} className="px-5 py-2 rounded-xl bg-red-500 hover:bg-red-600 text-white font-medium text-sm">Confirm</button>
                        </div>
                    </div>
                </div>
            )}

            {/* RESULT POPUP */}
            {resultPopup && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                    <div className="bg-white w-[95%] max-w-lg rounded-2xl shadow-2xl p-8 text-center">
                        <div className={`w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 ${resultPopup.status === "SUCCESS" ? "bg-green-100" : "bg-red-100"}`}>
                            <span className="text-3xl">{resultPopup.status === "SUCCESS" ? "✓" : "✕"}</span>
                        </div>
                        <h2 className={`text-2xl font-bold mb-2 ${resultPopup.status === "SUCCESS" ? "text-green-600" : "text-red-600"}`}>
                            {resultPopup.status}
                        </h2>
                        <p className="text-gray-600 mb-5">{resultPopup.message}</p>
                        {resultPopup.status === "SUCCESS" && resultPopup.txnId && (
                            <div className="bg-gray-50 rounded-xl p-4 text-sm space-y-1.5 mb-5 text-left border">
                                <p><span className="text-gray-400">Txn ID</span> <span className="font-semibold float-right">{resultPopup.txnId}</span></p>
                                {resultPopup.walletBalance !== undefined ? (
                                    <p><span className="text-gray-400">Wallet Balance</span> <span className="font-semibold float-right">₹ {Number(resultPopup.walletBalance).toLocaleString("en-IN")}</span></p>
                                ) : (
                                    <>
                                        <p><span className="text-gray-400">Sender Balance</span> <span className="font-semibold float-right">₹ {resultPopup.senderBalance}</span></p>
                                        <p><span className="text-gray-400">Receiver Balance</span> <span className="font-semibold float-right">₹ {resultPopup.receiverBalance}</span></p>
                                    </>
                                )}
                            </div>
                        )}
                        <button onClick={async () => { setResultPopup(null); await refreshUserData(); }}
                            className="px-8 py-2.5 bg-[#0A2A4F] hover:bg-[#123b6e] text-white rounded-xl font-semibold text-sm transition-colors">
                            OK
                        </button>
                    </div>
                </div>
            )}

            {/* BUSINESS WALLET CREDIT CONFIRM MODAL */}
            {bwcShowConfirm && (
                <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
                    <div className="bg-white rounded-2xl p-6 w-[90%] max-w-md shadow-2xl">
                        <h2 className="text-lg font-bold mb-1 text-gray-800">Confirm Business Wallet Credit</h2>
                        <p className="text-sm text-gray-500 mb-2">
                            Credit <b>₹{Number(bwcAmount).toLocaleString("en-IN")}</b> to <b>{userData?.username}</b>'s business wallet?
                        </p>
                        <p className="text-xs text-gray-400 mb-5">Account No: {userData?.accountNumber}</p>
                        <div className="flex justify-end gap-3">
                            <button onClick={() => setBwcShowConfirm(false)} className="px-5 py-2 rounded-xl bg-gray-100 text-gray-700 font-medium text-sm hover:bg-gray-200">Cancel</button>
                            <button onClick={handleBusinessWalletCredit} disabled={bwcLoading} className="px-5 py-2 rounded-xl bg-green-700 hover:bg-green-800 disabled:opacity-60 text-white font-medium text-sm">
                                {bwcLoading ? "Processing..." : "Confirm"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* OD CONFIRM MODAL */}
            {odConfirmAction && (
                <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
                    <div className="bg-white rounded-2xl p-6 w-[90%] max-w-md shadow-2xl">
                        <h2 className="text-lg font-bold mb-1 text-gray-800">
                            Confirm{" "}
                            {odConfirmAction === "ENABLE" ? "Enable OD"
                                : odConfirmAction === "UPDATE" ? "Update OD"
                                    : odConfirmAction === "DISABLE" ? "Disable OD"
                                        : "Unblock OD"}
                        </h2>
                        <p className="text-sm text-gray-500 mb-5">
                            {odConfirmAction === "ENABLE" && <>Enable OD for <b>{userData?.username}</b> with credit limit <b>₹{Number(odCreditLimit).toLocaleString("en-IN")}</b> and penalty fee <b>₹{Number(odPenalty || 0).toLocaleString("en-IN")}</b>?</>}
                            {odConfirmAction === "UPDATE" && <>Update OD for <b>{userData?.username}</b> — credit limit <b>₹{Number(odCreditLimit).toLocaleString("en-IN")}</b>, penalty fee <b>₹{Number(odPenalty || 0).toLocaleString("en-IN")}</b>?</>}
                            {odConfirmAction === "DISABLE" && <>Disable OD for <b>{userData?.username}</b>? This will fail if there is any outstanding balance.</>}
                            {odConfirmAction === "UNBLOCK" && <>Manually unblock OD for <b>{userData?.username}</b>? Use only if penalty has been collected offline.</>}
                        </p>
                        <div className="flex justify-end gap-3">
                            <button onClick={() => setOdConfirmAction(null)} className="px-5 py-2 rounded-xl bg-gray-100 text-gray-700 font-medium text-sm hover:bg-gray-200">Cancel</button>
                            <button
                                onClick={executeOdAction}
                                disabled={odActionLoading}
                                className={`px-5 py-2 rounded-xl text-white font-medium text-sm disabled:opacity-50 transition-colors ${odConfirmAction === "DISABLE" ? "bg-red-500 hover:bg-red-600" : "bg-amber-500 hover:bg-amber-600"
                                    }`}>
                                {odActionLoading ? "Processing..." : "Confirm"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* OD OTP MODAL */}
            {odOtpPopup.open && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 px-4">
                    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden">
                        <div className="bg-gradient-to-r from-[#0A2A4F] to-[#1a4a8f] px-6 py-4 flex items-center justify-between">
                            <h3 className="text-white font-bold text-base">OTP Verification</h3>
                            <button
                                onClick={() => { setOdOtpPopup({ open: false, pendingPayload: null, apiType: null, sentTo: [], apiMessage: "" }); setOdOtpInput(""); setOdOtpError(""); }}
                                disabled={odOtpLoading}
                                className="text-white/70 hover:text-white text-xl leading-none disabled:opacity-40"
                            >✕</button>
                        </div>
                        <div className="px-6 py-5 space-y-4">
                            <div>
                                <p className="text-sm text-gray-600 mb-2">OTP has been sent to:</p>
                                <div className="flex flex-wrap gap-2">
                                    {odOtpPopup.sentTo.map((num, i) => (
                                        <span key={i} className="px-3 py-1 bg-amber-50 border border-amber-200 rounded-full text-sm font-semibold text-amber-700 tracking-wider">{num}</span>
                                    ))}
                                </div>
                            </div>
                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2">Enter 6-digit OTP</label>
                                <input
                                    type="text"
                                    inputMode="numeric"
                                    maxLength={6}
                                    value={odOtpInput}
                                    onChange={e => { setOdOtpInput(e.target.value.replace(/\D/g, "")); setOdOtpError(""); }}
                                    placeholder="_ _ _ _ _ _"
                                    className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-amber-500 focus:ring-2 focus:ring-amber-100 outline-none text-gray-800 font-bold tracking-[0.6em] text-center text-xl"
                                />
                                <p className="text-right text-xs mt-1" style={{ color: odOtpInput.length === 6 ? "#16a34a" : "#9ca3af" }}>
                                    {odOtpInput.length} / 6
                                </p>
                            </div>
                            {odOtpError && (
                                <div className="bg-red-50 border border-red-200 rounded-xl px-4 py-3 text-sm text-red-600 font-medium">{odOtpError}</div>
                            )}
                            <button
                                onClick={handleOdOtpSubmit}
                                disabled={odOtpLoading || odOtpInput.length !== 6}
                                className="w-full py-3 rounded-xl bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600 text-white font-semibold text-sm transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                {odOtpLoading ? (
                                    <span className="flex items-center justify-center gap-2">
                                        <svg className="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"/></svg>
                                        Verifying...
                                    </span>
                                ) : "Approve"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* LIEN HISTORY EDIT MODAL */}
            {lienEditPopup.open && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm px-4">
                    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden">

                        {/* Modal header */}
                        <div className="bg-gradient-to-r from-[#0A2A4F] to-[#1a4a8f] px-6 py-4 flex items-center justify-between">
                            <div>
                                <h3 className="text-white font-bold text-base">Edit Lien History</h3>
                                <p className="text-blue-200 text-xs mt-0.5">{lienEditPopup.row?.lienId ?? ""}</p>
                            </div>
                            <button
                                onClick={closeLienEditModal}
                                disabled={lienEditLoading}
                                className="text-white/70 hover:text-white text-xl leading-none disabled:opacity-40"
                            >
                                ✕
                            </button>
                        </div>

                        {/* Modal body */}
                        <div className="px-6 py-5 space-y-4">

                            {/* Info row */}
                            <div className="bg-[#EFF6FF] border border-blue-100 rounded-xl px-4 py-3 text-sm text-[#0A2A4F]">
                                <span className="font-medium">Mobile:</span> {lienEditPopup.row?.mobileNumber ?? userData?.mobile ?? "-"}
                            </div>

                            {/* Lien Amount */}
                            <div>
                                <label className="block text-xs font-semibold text-gray-600 mb-1.5 uppercase tracking-wide">
                                    Lien Amount <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="number"
                                    value={lienEditForm.lienAmount}
                                    onChange={(e) => setLienEditForm({ ...lienEditForm, lienAmount: e.target.value })}
                                    placeholder="Enter lien amount"
                                    className="w-full border border-[#CBD5E1] rounded-xl px-4 py-2.5 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#0A2A4F]/20 focus:border-[#0A2A4F]"
                                />
                            </div>

                            {/* Remark */}
                            <div>
                                <label className="block text-xs font-semibold text-gray-600 mb-1.5 uppercase tracking-wide">
                                    Remark
                                </label>
                                <textarea
                                    rows={3}
                                    value={lienEditForm.remark}
                                    onChange={(e) => setLienEditForm({ ...lienEditForm, remark: e.target.value })}
                                    placeholder="Enter remark"
                                    className="w-full border border-[#CBD5E1] rounded-xl px-4 py-2.5 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#0A2A4F]/20 focus:border-[#0A2A4F] resize-none"
                                />
                            </div>

                            {/* Modified By (read-only) */}
                            <div>
                                <label className="block text-xs font-semibold text-gray-600 mb-1.5 uppercase tracking-wide">
                                    Modified By
                                </label>
                                <input
                                    type="text"
                                    value={username ?? ""}
                                    readOnly
                                    className="w-full border border-[#E5E7EB] rounded-xl px-4 py-2.5 text-sm text-gray-500 bg-gray-50 cursor-not-allowed"
                                />
                            </div>

                            {/* Error */}
                            {lienEditError && (
                                <div className="bg-red-50 border border-red-200 rounded-xl px-4 py-2.5 text-sm text-red-600">
                                    {lienEditError}
                                </div>
                            )}
                        </div>

                        {/* Modal footer */}
                        <div className="px-6 py-4 border-t border-[#E5E7EB] flex justify-end gap-3">
                            <button
                                onClick={closeLienEditModal}
                                disabled={lienEditLoading}
                                className="px-5 py-2.5 rounded-xl border border-[#CBD5E1] text-sm font-semibold text-gray-600 hover:bg-gray-50 disabled:opacity-40 transition"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleLienEditSubmit}
                                disabled={lienEditLoading}
                                className="px-6 py-2.5 rounded-xl bg-[#0A2A4F] hover:bg-[#0d3566] text-white text-sm font-semibold disabled:opacity-50 transition flex items-center gap-2"
                            >
                                {lienEditLoading ? (
                                    <>
                                        <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin inline-block" />
                                        Saving...
                                    </>
                                ) : "Submit"}
                            </button>
                        </div>

                    </div>
                </div>
            )}

            {/* LIEN CONFIRM MODAL */}
            {lienConfirm && (
                <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
                    <div className="bg-white rounded-2xl p-6 w-[90%] max-w-md shadow-2xl">
                        <h2 className="text-lg font-bold mb-1 text-gray-800">
                            Confirm {lienMode === "ADD" ? "Add Lien" : lienMode === "SUB" ? "Subtract Lien" : "Release Lien"}
                        </h2>
                        <p className="text-sm text-gray-500 mb-5">
                            {lienMode === "ADD" && <>Add a lien of <b>₹{Number(lienAmount).toLocaleString("en-IN")}</b> on wallet of <b>{userData?.username}</b>?</>}
                            {lienMode === "SUB" && <>Subtract <b>₹{Number(lienAmount).toLocaleString("en-IN")}</b> from the lien on <b>{userData?.username}</b>'s wallet?</>}
                            {lienMode === "UNHOLD" && <>Release (unhold) the full lien amount on <b>{userData?.username}</b>'s wallet? This sets lien to zero.</>}
                        </p>
                        <div className="flex justify-end gap-3">
                            <button onClick={() => setLienConfirm(false)} className="px-5 py-2 rounded-xl bg-gray-100 text-gray-700 font-medium text-sm hover:bg-gray-200">Cancel</button>
                            <button
                                onClick={executeLienAction}
                                disabled={lienLoading}
                                className={`px-5 py-2 rounded-xl text-white font-medium text-sm disabled:opacity-50 transition-colors ${lienMode === "UNHOLD" ? "bg-green-500 hover:bg-green-600" : "bg-indigo-500 hover:bg-indigo-600"}`}>
                                {lienLoading ? "Processing..." : "Confirm"}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );

};

export default SearchUser;


